import { render } from "./SettingsInforming.vue?vue&type=template&id=71ba1ceb&scoped=true"
import script from "./SettingsInforming.vue?vue&type=script&lang=js"
export * from "./SettingsInforming.vue?vue&type=script&lang=js"

import "./SettingsInforming.vue?vue&type=style&index=0&id=71ba1ceb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ba1ceb"]])

export default __exports__